import { stringify as qsStringify } from 'query-string';
import type { CmdbObjectId, WorkspaceId } from '@atlassian/jira-servicedesk-insight-shared-types';
import type { ObjectByIdActivityRequest, ObjectRecentRequest } from '../types/object';
import { getCmdbRestBaseUrl } from './index';

/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/object
 */
const getCmdbObjectUrl = (workspaceId: WorkspaceId) => `${getCmdbRestBaseUrl(workspaceId)}/object`;
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/object/${objectId}
 */
export const getCmdbObjectByIdUrl = (workspaceId: WorkspaceId, objectId: CmdbObjectId) =>
	`${getCmdbObjectUrl(workspaceId)}/${objectId}`;
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/object/${objectId}/activity
 */
export const getCmdbObjectByIdActivityUrl = (
	workspaceId: WorkspaceId,
	objectId: CmdbObjectId,
	queryParams: ObjectByIdActivityRequest,
) => `${getCmdbObjectByIdUrl(workspaceId, objectId)}/activity?${qsStringify(queryParams)}`;
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/object/${objectId}/avatar
 */
export const getCmdbObjectByIdAvatarUrl = (workspaceId: WorkspaceId, objectId: CmdbObjectId) =>
	`${getCmdbObjectByIdUrl(workspaceId, objectId)}/avatar`;
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/object/${objectId}/referenceinfo
 */
export const getCmdbObjectByIdReferenceInfoUrl = (
	workspaceId: WorkspaceId,
	objectId: CmdbObjectId,
) => `${getCmdbObjectByIdUrl(workspaceId, objectId)}/referenceinfo`;
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/object/clone/${objectId}
 */
export const getCmdbObjectCloneByIdUrl = (workspaceId: WorkspaceId, objectId: CmdbObjectId) =>
	`${getCmdbObjectUrl(workspaceId)}/clone/${objectId}`;
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/object/create
 */
export const getCmdbObjectCreateUrl = (workspaceId: WorkspaceId) =>
	`${getCmdbObjectUrl(workspaceId)}/create`;
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/object/navlist
 */
export const getCmdbObjectNavlistUrl = (workspaceId: WorkspaceId) =>
	`${getCmdbObjectUrl(workspaceId)}/navlist`;
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/object/navlist/aql
 */
export const getCmdbObjectNavlistQueryLanguageUrl = (workspaceId: WorkspaceId) =>
	`${getCmdbObjectNavlistUrl(workspaceId)}/aql`;
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/object/recent
 */
export const getCmdbObjectRecentUrl = (
	workspaceId: WorkspaceId,
	queryParams: ObjectRecentRequest,
) => `${getCmdbObjectUrl(workspaceId)}/recent?${qsStringify(queryParams)}`;
